import React from 'react';
import { Outlet } from 'react-router-dom';

export default function VesselLiveTracking() {
  return <Outlet />;
}
